/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Tag } from "antd-mobile";
import { intl } from "../services/intlGlobalProvider";
import styled from "styled-components";
import PropTypes from "prop-types";
import * as _ from "underscore";
import * as userSelectors from "../selectors/user";
import * as addOnSelectors from "../selectors/addOn";
import * as variantSelectors from "../selectors/variant";
import Color from "../utils/Color";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
`;

const StyledMainContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  padding: 0 5px;
  line-height: 1em;
`;

const StyledImageContainer = styled.div`
  width: 28%;
`;

const StyledContentContainer = styled.div`
  width: 52%;
`;

const StyledContentContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
`;

const StyledSideInfoContainer = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`;

const StyledContentTitle = styled.span`
  text-align: start;
  color: black;
  font-size: 0.9em;
`;

const StyledContentSubtitle = styled.span`
  color: gray;
  font-size: 0.8em;
`;

const StyledContentDes = styled.span`
  color: ${Color.Secondary};
  font-size: 0.75em;
`;

const StyledPrice = styled.span`
  margin-top: 8px;
  font-size: 0.8em;
  color: black;
`;

class OrderDetailsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formattedAddOnText = addOn => {
    const addOnTitle = addOnSelectors.getAddOnName(addOn);
    const addOnQuantity = addOnSelectors.getAddOnQuantity(addOn);
    if (addOnQuantity > 0) {
      return `+${addOnQuantity}x ${addOnTitle}`;
    } else {
      return false;
    }
  };

  formattedVariantText = variant => {
    const variantTitle = variantSelectors.getVariantName(variant);
    const variantItems = variantSelectors.getVariantItems(variant);
    let variantItem = variantItems
      ? variantItems.find(variantItem => {
          const selectedVariant = variantSelectors.getVariantItemIsSelected(
            variantItem
          );
          if (selectedVariant) {
            return variantItem;
          }
        })
      : false;
    const variantItemName = variantSelectors.getVariantItemName(variantItem);
    return `${variantTitle} - ${variantItemName}`;
  };

  render() {
    const { item } = this.props;
    const foodImageLarge = userSelectors.getUserCartItemStallItemImageLargeSrc(
      item
    );
    const quantity = userSelectors.getUserCartItemStallItemQuantity(item);
    const title = userSelectors.getUserCartItemStallItemTitle(item);
    const variants = userSelectors.getUserCartItemStallItemVariants(item);
    const addOns = userSelectors.getUserCartItemStallItemAddOns(item);
    const addOnItems = addOns.filter(addOnItem => {
      return parseInt(addOnItem.quantity) > 0;
    });
    const totalPrice = userSelectors.getUserCartItemStallItemTotalPriceWithCurrency(
      item
    );
    const isTakeAway = userSelectors.getUserCartItemStallItemIsTakeAway(item);

    return (
      <StyledContainer>
        <StyledMainContainer>
          <StyledImageContainer>
            <img
              ref={ref => (this.itemImage = ref)}
              src={
                foodImageLarge
                  ? foodImageLarge
                  : "https://via.placeholder.com/100x100"
              }
              alt=""
              style={{
                width: "100%",
                objectFit: "cover",
                objectPosition: "center"
              }}
              onLoad={() => {
                window.dispatchEvent(new Event("resize"));
              }}
            />
          </StyledImageContainer>
          <StyledContentContainer>
            <StyledContentContentContainer>
              <StyledContentTitle>
                {quantity}x {title}
              </StyledContentTitle>
              {!_.isEmpty(variants) ? (
                <StyledContentSubtitle style={{ marginTop: "4px" }}>
                  <FormattedMessage id="cart.order.item.variant.title" />
                </StyledContentSubtitle>
              ) : null}
              {!_.isEmpty(variants)
                ? variants.map((variant, index) => {
                    return (
                      <StyledContentDes key={index}>
                        {this.formattedVariantText(variant)}
                      </StyledContentDes>
                    );
                  })
                : null}
              {!_.isEmpty(addOnItems) ? (
                <StyledContentSubtitle style={{ marginTop: "4px" }}>
                  <FormattedMessage id="cart.order.item.addon.title" />
                </StyledContentSubtitle>
              ) : null}
              {!_.isEmpty(addOnItems)
                ? addOnItems.map((addon, index) => {
                    return (
                      <StyledContentDes key={index}>
                        {this.formattedAddOnText(addon)}
                      </StyledContentDes>
                    );
                  })
                : null}
            </StyledContentContentContainer>
          </StyledContentContainer>
          <StyledSideInfoContainer>
            <Tag
              disabled
              style={{
                padding: "0px 5px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                height: "auto",
                fontSize: "0.8em",
                border: "unset",
                color: "white",
                background: isTakeAway
                  ? Color.takeAwayLabelColor
                  : Color.Primary
              }}
            >
              {intl.formatMessage({
                id: isTakeAway
                  ? "cart.order.item.take.away.title"
                  : "cart.order.item.dine.in.title"
              })}
            </Tag>
            <StyledPrice>{totalPrice}</StyledPrice>
          </StyledSideInfoContainer>
        </StyledMainContainer>
      </StyledContainer>
    );
  }
}

OrderDetailsItem.propTypes = {
  item: PropTypes.object.isRequired
};

export default OrderDetailsItem;



// WEBPACK FOOTER //
// ./src/components/OrderDetailsItem.js